/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Duration_Unknown_ErrorInputs */

const en_audio_description_export_duration_unknown_error = /** @type {(inputs: Audio_Description_Export_Duration_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to determine the duration of the source media file.`)
};

const fr_audio_description_export_duration_unknown_error = /** @type {(inputs: Audio_Description_Export_Duration_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de determiner la duree du fichier media source.`)
};

const de_audio_description_export_duration_unknown_error = /** @type {(inputs: Audio_Description_Export_Duration_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Dauer der Quellmediendatei konnte nicht ermittelt werden.`)
};

const it_audio_description_export_duration_unknown_error = /** @type {(inputs: Audio_Description_Export_Duration_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile determinare la durata del file multimediale di origine.`)
};

const ru_audio_description_export_duration_unknown_error = /** @type {(inputs: Audio_Description_Export_Duration_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось определить продолжительность исходного медиафайла.`)
};

const es_audio_description_export_duration_unknown_error = /** @type {(inputs: Audio_Description_Export_Duration_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede determinar la duración del archivo multimedia de origen.`)
};

const zh_cn2_audio_description_export_duration_unknown_error = /** @type {(inputs: Audio_Description_Export_Duration_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法确定源媒体文件的持续时间。`)
};

const ja_audio_description_export_duration_unknown_error = /** @type {(inputs: Audio_Description_Export_Duration_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソース メディア ファイルの継続時間を特定できません。`)
};

const hi_audio_description_export_duration_unknown_error = /** @type {(inputs: Audio_Description_Export_Duration_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत मीडिया फ़ाइल की अवधि निर्धारित करने में असमर्थ।`)
};

const pt_pt2_audio_description_export_duration_unknown_error = /** @type {(inputs: Audio_Description_Export_Duration_Unknown_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível determinar a duração do arquivo de mídia de origem.`)
};

/**
* | output |
* | --- |
* | "Unable to determine the duration of the source media file." |
*
* @param {Audio_Description_Export_Duration_Unknown_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_duration_unknown_error = /** @type {((inputs?: Audio_Description_Export_Duration_Unknown_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Duration_Unknown_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_duration_unknown_error(inputs)
	if (locale === "de") return de_audio_description_export_duration_unknown_error(inputs)
	if (locale === "it") return it_audio_description_export_duration_unknown_error(inputs)
	if (locale === "ru") return ru_audio_description_export_duration_unknown_error(inputs)
	if (locale === "es") return es_audio_description_export_duration_unknown_error(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_duration_unknown_error(inputs)
	if (locale === "ja") return ja_audio_description_export_duration_unknown_error(inputs)
	if (locale === "hi") return hi_audio_description_export_duration_unknown_error(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_duration_unknown_error(inputs)
	return en_audio_description_export_duration_unknown_error(inputs)
});